/**
 * External Dependencies
 */
import 'jquery';
import 'bootstrap';

// Import Slick
import 'slick-carousel/slick/slick.min';

$(document).ready(() => {
   $('.load-more-faqs').click(function(){
    $('.more-faqs').slideToggle();
    $(this).fadeOut();
   });

   $(".the-quote-slider").slick({

      // normal options...
      infinite: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true,
    });

    $(".home-hero-slider").slick({
      // normal options...
      infinite: true,
      dots: true,
      autoplay: true,
      autoplaySpeed: 5000,      
    });

    $(".experts-slider").slick({
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });

    $('.link-select .link-option-first').click(function(){
      $('.link-option-drop').slideToggle('fast');
    });


    $('.expert-location-options .link-option').click(function(){
      $('.link-option-first.location-placeholder').remove();
    });

    $('.experts-filter .location-option.unselected').on('click', function () {
      $('.location-option.link-option-first').removeClass('link-option-first').addClass('unselected').appendTo('.link-option-drop')
      $(this)
        .prependTo( $('.link-select') )
        .removeClass('unselected')
        .addClass('link-option-first');


        var exInput = $('.expert-search input').val();
        var exLocation = $(this).attr('data-expert-location');

          $('.search-btn').attr('href', exLocation + '?es=' + exInput);



        $('.link-option-drop').slideToggle('fast');
    });

    $('.side-nav-btn a.mega-menu-link, .close-side-nav').on('click', function () {
      event.preventDefault();
      $('.side-nav').toggleClass('open');
    });

});

$('.expert-search input').on("input", function() {
  var dInput = this.value;
  var dLocation = $('.link-option-first').attr('data-expert-location');

  $('.search-btn').attr('href', dLocation + '?es=' + dInput);
});


$(".expert-search input").on('keyup', function (e) {
  if (e.key === 'Enter' || e.keyCode === 13) {
      // Do something
      $('.search-btn').click();
  }
});

$('.secondary-nav i.fa-search').click(function(){
  $('.hh-search').fadeToggle('fast');
});

$('.mobile-nav-btn').click(function(){
  $('body').toggleClass('mobile-nav-open');
});

var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    }
  });
}




